import Model from "../Model";

class BuildingAcumulated extends Model {
    buildUrl ({query}) {
        return ['api/building/acumulated'];
    }
};

export default new BuildingAcumulated;